import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logoamerisa from '../assets/logoamerisa.png';
import Sidebar from '../components/Sidebar';
import Accordion from '../components/ui/accordion';
import Select from 'react-select';
import { Modal, Box, Typography, Button, TextField } from '@mui/material';
import Topbar from '../components/Topbar';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const tipoMotivosOptions = [
  { value: 'RECHAZO TOTAL', label: 'RECHAZO TOTAL' },
  { value: 'RECHAZO PARCIAL', label: 'RECHAZO PARCIAL' },
  //{ value: 'TRANSPORTISTA', label: 'TRANSPORTISTA' },
  //{ value: 'INSTALACIONES', label: 'INSTALACIONES' },
  //{ value: 'OTRO', label: 'OTRO' },
];

const Catalog = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeItem, setActiveItem] = useState('Catálogos');
  const [ubicaciones, setUbicaciones] = useState([]);
  const [motivosRechazo, setMotivosRechazo] = useState([]);
  const [requerimientos, setRequerimientos] = useState([]);
  const [adicionales, setAdicionales] = useState([]);
  const [motivoModalIsOpen, setMotivoModalIsOpen] = useState(false);
  const [newMotivo, setNewMotivo] = useState({
    descripcion: '',
    tipo: ''
  });
  const [requerimientoModalIsOpen, setRequerimientoModalIsOpen] = useState(false);
  const [newRequerimiento, setNewRequerimiento] = useState({
    requerimiento: ''
  });
  const [ubicacionModalIsOpen, setUbicacionModalIsOpen] = useState(false);
  const [newUbicacion, setNewUbicacion] = useState({
    address: '',
    City: '',
    State: '',
    alias: '',
    codigo_Postal: '',
    customer: ''
  });
  const [selectedClient, setSelectedClient] = useState(null);
  const [clients, setClients] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const navigate = useNavigate();

  const handleLogout = () => {
    console.log('Logout clicked!');
    localStorage.clear();
    setTimeout(() => {
      navigate('/login');
    }, 0);
  };

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/clients/`);
        const data = await response.json();
        setClients(data);
      } catch (error) {
        console.error('Error fetching clients:', error);
      }
    };

    fetchClients();
  }, []);

  useEffect(() => {
    const fetchMotivosRechazo = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/motivos`);
        const data = await response.json();
        setMotivosRechazo(data);
      } catch (error) {
        console.error('Error buscando motivos de rechazo:', error);
      }
    };

    fetchMotivosRechazo();
  }, []);

  useEffect(() => {
    const fetchRequerimientos = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/requerimientos`);
        const data = await response.json();
        setRequerimientos(data);
      } catch (error) {
        console.error('Error buscando requerimientos:', error);
      }
    };

    fetchRequerimientos();
  }, []);

  const handleClientChange = (selectedOption) => {
    setSelectedClient(selectedOption);
    if (selectedOption) {
      const clientUbicaciones = clients.filter(client => client.customer === selectedOption.label);
      setUbicaciones(clientUbicaciones);
    } else {
      setUbicaciones([]);
    }
  };

  // Función para buscar adicionales
  const buscarAdicionales = async (inputValue) => {
    try {
      const response = await fetch(`/api/adicionales?q=${inputValue}`);
      const data = await response.json();
      setAdicionales(data);
    } catch (error) {
      console.error('Error buscando adicionales:', error);
    }
  };

  const handleMotivoInputChange = (e) => {
    const { name, value } = e.target;
    setNewMotivo({ ...newMotivo, [name]: value.toUpperCase() });
  };

  const handleAddMotivo = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/motivos/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(newMotivo)
      });
      const data = await response.json();
      setMotivosRechazo([...motivosRechazo, data]);
      setNewMotivo({ descripcion: '', tipo: '' });
      setMotivoModalIsOpen(false);
    } catch (error) {
      console.error('Error añadiendo motivo:', error);
    }
  };

  const handleAddRequerimiento = async (e) => {
    e.preventDefault();
    try {
      console.log('Enviando requerimiento:', newRequerimiento); // Debug
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/requerimientos/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(newRequerimiento)
      });
      const data = await response.json();
      setRequerimientos([...requerimientos, data]);
      setNewRequerimiento({ requerimiento: '' });
      setRequerimientoModalIsOpen(false);
    } catch (error) {
      console.error('Error añadiendo requerimiento:', error);
    }
  };

  const handleUbicacionInputChange = (e) => {
    const { name, value } = e.target;
    setNewUbicacion({ ...newUbicacion, [name]: value });
  };

  const handleAddUbicacion = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/ubicaciones/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(newUbicacion)
      });
      const data = await response.json();
      setUbicaciones([...ubicaciones, data]);
      setNewUbicacion({ address: '', City: '', State: '', alias: '', codigo_Postal: '', customer: '' });
      setUbicacionModalIsOpen(false);
    } catch (error) {
      console.error('Error añadiendo ubicación:', error);
    }
  };

  // Componente de autocompletado reutilizable
  const Autocomplete = ({ placeholder, options, onSelect, value }) => {
    return (
      <Select
        placeholder={placeholder}
        options={options.map((item) => ({
          value: item.id,
          label: item.customer, // Use 'customer' property for the label
        }))}
        onChange={onSelect}
        value={value}
        isClearable
        isSearchable
        noOptionsMessage={() => "No hay resultados"}
      />
    );
  };

  return (
    <div className="flex">
      {/* Sidebar */}
      <Sidebar
        isOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
        onLogout={handleLogout}
      />

      {/* Contenido principal */}
      <div
        className={`transition-all duration-300 flex-1 ${
          sidebarOpen ? 'ml-64' : 'ml-16'
        } bg-gray-100 min-h-screen p-6`}
      >
        {/* Replace with Topbar component */}
        <Topbar 
          
          searchValue={searchValue} 
          onSearchChange={setSearchValue}
        />

        {/* Secciones colapsables */}
        <div className="mt-6 space-y-4">
          {/* Sección: Ubicaciones */}
          <Accordion title="Ubicaciones">
            <div className="mb-4">
              <Autocomplete
                placeholder="Seleccionar cliente..."
                options={Array.from(new Set(clients.map(client => client.customer)))
                  .map(customer => clients.find(client => client.customer === customer))}
                onSelect={handleClientChange}
                value={selectedClient}
              />
            </div>
            {ubicaciones.length > 0 ? (
              <ul className="space-y-2">
                {ubicaciones.map((ubicacion) => (
                  <li key={ubicacion.id} className="p-2 bg-white rounded-md shadow-sm">
                    <div><strong>Alias:</strong> {ubicacion.alias}</div>
                    <div><strong>Cliente:</strong> {ubicacion.customer}</div>
                    <div><strong>Dirección:</strong> {ubicacion.address}</div>
                    <div><strong>Ciudad:</strong> {ubicacion.City}</div>
                    <div><strong>Estado:</strong> {ubicacion.State}</div>
                    <div><strong>Código Postal:</strong> {ubicacion.codigo_Postal}</div>
                  </li>
                ))}
              </ul>
            ) : (
              <p>No se encontraron ubicaciones para el cliente seleccionado.</p>
            )}
            {/*<div className="mt-4 pt-2 border-t border-gray-200">
              <Button
                variant="contained"
                color="primary"
                onClick={() => setUbicacionModalIsOpen(true)}
              >
                Añadir Ubicación
              </Button>
            </div>*/}
          </Accordion>

          {/* Sección: Motivos de rechazo */}
          <Accordion title="Motivos de rechazo">
            <div className="mb-4">
              <div className="p-4 bg-white rounded-md shadow-sm">
                <h3 className="text-lg font-semibold mb-4">Motivos de Rechazo Registrados</h3>
                {motivosRechazo.length > 0 ? (
                  <div className="max-h-[400px] overflow-y-auto">
                    <ul className="space-y-2 pr-2">
                      {motivosRechazo.map((motivo) => (
                        <li 
                          key={motivo.id} 
                          className="p-2 bg-gray-50 rounded-md hover:bg-gray-100 transition-colors"
                        >
                          <span className="font-medium">{motivo.descripcion}</span>
                          {motivo.tipo && (
                            <span className="ml-2 text-sm text-gray-600">({motivo.tipo})</span>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                ) : (
                  <p>No hay motivos de rechazo registrados.</p>
                )}
                <div className="mt-4 pt-2 border-t border-gray-200">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => setMotivoModalIsOpen(true)}
                  >
                    Añadir Motivo
                  </Button>
                </div>
              </div>
            </div>
          </Accordion>

           {/* Sección: requerimientos */}
           <Accordion title="Requerimientos">
            <div className="mb-4">
              <div className="p-4 bg-white rounded-md shadow-sm">
                <h3 className="text-lg font-semibold mb-4">Requerimientos Registrados</h3>
                {requerimientos.length > 0 ? (
                  <div className="max-h-[400px] overflow-y-auto">
                    <ul className="space-y-2 pr-2">
                      {requerimientos.map((req) => (
                        <li 
                          key={req.id} 
                          className="p-2 bg-gray-50 rounded-md hover:bg-gray-100 transition-colors"
                        >
                          <span className="font-medium">{req.requerimiento}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                ) : (
                  <p>No hay requerimientos registrados.</p>
                )}
                <div className="mt-4 pt-2 border-t border-gray-200">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => setRequerimientoModalIsOpen(true)}
                  >
                    Añadir Requerimiento
                  </Button>
                </div>
              </div>
            </div>
          </Accordion>

          {/* Sección: Adicionales */}
          <Accordion title="Adicionales">
            <div className="mb-4">
              <Autocomplete
                placeholder="Buscar adicionales..."
                onSearch={buscarAdicionales}
                options={adicionales}
              />
            </div>
            {adicionales.length > 0 ? (
              <ul className="space-y-2">
                {adicionales.map((adicional) => (
                  <li key={adicional.id} className="p-2 bg-white rounded-md shadow-sm">
                    {adicional.nombre}
                  </li>
                ))}
              </ul>
            ) : (
              <p>No se encontraron resultados.</p>
            )}
          </Accordion>
        </div>
      </div>

      {/* Modal para añadir nuevo motivo de rechazo */}
      <Modal
        open={motivoModalIsOpen}
        onClose={() => setMotivoModalIsOpen(false)}
        aria-labelledby="modal-modal-title"
      >
        <Box sx={style}>
          <Typography variant="h6" component="h2">
            Añadir Motivo de Rechazo
          </Typography>
          <form onSubmit={handleAddMotivo}>
            <TextField
              label="Descripción"
              name="descripcion"
              value={newMotivo.descripcion}
              onChange={handleMotivoInputChange}
              fullWidth
              margin="normal"
              required
            />
            <Select
              placeholder="Seleccionar tipo..."
              options={tipoMotivosOptions}
              onChange={(selectedOption) => setNewMotivo({
                ...newMotivo,
                tipo: selectedOption ? selectedOption.value : ''
              })}
              styles={{
                control: (provided) => ({
                  ...provided,
                  marginTop: '16px',
                  marginBottom: '8px',
                })
              }}
              isClearable
            />
            <Box mt={2} display="flex" justifyContent="flex-end" gap={2}>
              <Button
                onClick={() => setMotivoModalIsOpen(false)}
                variant="outlined"
              >
                Cancelar
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
              >
                Añadir
              </Button>
            </Box>
          </form>
        </Box>
      </Modal>

      {/* Modal para añadir nueva ubicación */}
      <Modal
        open={ubicacionModalIsOpen}
        onClose={() => setUbicacionModalIsOpen(false)}
        aria-labelledby="modal-modal-title"
      >
        <Box sx={style}>
          <Typography variant="h6" component="h2">
            Añadir Ubicación
          </Typography>
          <form onSubmit={handleAddUbicacion}>
            <TextField
              label="Alias"
              name="alias"
              value={newUbicacion.alias}
              onChange={handleUbicacionInputChange}
              fullWidth
              margin="normal"
              required
            />
            <TextField
              label="Cliente"
              name="customer"
              value={newUbicacion.customer}
              onChange={handleUbicacionInputChange}
              fullWidth
              margin="normal"
              required
            />
            <TextField
              label="Dirección"
              name="address"
              value={newUbicacion.address}
              onChange={handleUbicacionInputChange}
              fullWidth
              margin="normal"
              required
            />
            <TextField
              label="Ciudad"
              name="City"
              value={newUbicacion.City}
              onChange={handleUbicacionInputChange}
              fullWidth
              margin="normal"
              required
            />
            <TextField
              label="Estado"
              name="State"
              value={newUbicacion.State}
              onChange={handleUbicacionInputChange}
              fullWidth
              margin="normal"
              required
            />
            <TextField
              label="Código Postal"
              name="codigo_Postal"
              value={newUbicacion.codigo_Postal}
              onChange={handleUbicacionInputChange}
              fullWidth
              margin="normal"
              required
            />
            <Box mt={2} display="flex" justifyContent="flex-end" gap={2}>
              <Button
                onClick={() => setUbicacionModalIsOpen(false)}
                variant="outlined"
              >
                Cancelar
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
              >
                Añadir
              </Button>
            </Box>
          </form>
        </Box>
      </Modal>

      {/* Modal para añadir nuevo requerimiento */}
      <Modal
        open={requerimientoModalIsOpen}
        onClose={() => setRequerimientoModalIsOpen(false)}
        aria-labelledby="modal-modal-title"
      >
        <Box sx={style}>
          <Typography variant="h6" component="h2">
            Añadir Requerimiento
          </Typography>
          <form onSubmit={handleAddRequerimiento}>
            <TextField
              label="Requerimiento"
              name="requerimiento"
              value={newRequerimiento.requerimiento}
              onChange={(e) => setNewRequerimiento({
                ...newRequerimiento,
                requerimiento: e.target.value.toUpperCase()
              })}
              fullWidth
              margin="normal"
              required
            />
            <Box mt={2} display="flex" justifyContent="flex-end" gap={2}>
              <Button
                onClick={() => setRequerimientoModalIsOpen(false)}
                variant="outlined"
              >
                Cancelar
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
              >
                Añadir
              </Button>
            </Box>
          </form>
        </Box>
      </Modal>
    </div>
  );
};

export default Catalog;